import {
  getActiveLanguages,
  getLanguages,
  putLanguages,
  getPrivacyCentreUrl,
  getPrivacyCentreSnippets,
  postSendDeveloperEmail,
  getPolicies,
  postUpdatePolicy,
  postDeletePolicy,
  getBasicStyling,
  postBasicStyling,
} from "@/requests/api/comply";
import { useMutation, useQuery } from "@tanstack/react-query";

export const useGetLanguages = () =>
  useQuery({
    queryKey: ["comply", "all", "languages"],
    queryFn: getLanguages,
  });

export const usePutLanguages = () =>
  useMutation({
    mutationKey: ["comply", "languages", "put"],
    mutationFn: putLanguages,
  });

export const useGetActiveLanguages = () =>
  useQuery({
    queryKey: ["comply", "active", "languages"],
    queryFn: getActiveLanguages,
  });

export const useGetPrivacyCentreUrl = () =>
  useQuery({
    queryKey: ["comply", "privacy-centre-url"],
    queryFn: getPrivacyCentreUrl,
  });

export const useGetPrivacyCentreSnippets = () =>
  useQuery({
    queryKey: ["comply", "privacy-centre-snippets"],
    queryFn: getPrivacyCentreSnippets,
  });

export const usePostSendDeveloperEmail = () =>
  useMutation({
    mutationFn: postSendDeveloperEmail,
  });

export const useGetPoliciesTable = ({
  enabled,
  queryKey,
  params,
}: ITableOptions) =>
  useQuery({
    enabled,
    queryKey,
    queryFn: ({ signal }) => getPolicies({ signal, params }),
  });

export const usePostUpdatePolicy = () =>
  useMutation({
    mutationFn: postUpdatePolicy,
  });

export const usePostDeletePolicy = () =>
  useMutation({
    mutationFn: postDeletePolicy,
  });

export const useGetBasicStyling = () =>
  useQuery({
    queryKey: ["comply", "basic-styling"],
    queryFn: getBasicStyling,
  });

export const usePostBasicStyling = () =>
  useMutation({
    mutationFn: postBasicStyling,
  });
